<template>
    <div id="Edit" >
        <div class="g-right-top width800">个人中心／编辑资料／基本信息</div>
        <div class="g-right-middle margintop20 width800">
            <router-link class="g-right-nav nav1" to='/per_admin/edit/jbxx'>基本信息</router-link>
            <!-- <router-link style="margin-left:20px" class="g-right-nav nav-dis nav2" to='/per_admin/edit/yyjl'>演艺经历</router-link>
            <router-link style="margin-left:20px" class="g-right-nav nav-dis nav3" to='/per_admin/edit/wdxz'>我的写真</router-link>
						<router-link style="margin-left:20px" class="g-right-nav nav-dis nav4" to='/per_admin/edit/wdsp'>我的视频</router-link> -->
						<font style="color: red;font-size: 12px;margin-left: 10px; line-height: 36px;">{{msg}}</font>

            <div class=" clearfix"></div>
            <div class="border-line"></div>

        </div>


            <router-view></router-view>

    </div>
</template>
<script>
import storage from '../../storage/storage.js'
	export default{
	data(){
		return{
			msg:''
		}
	},
	methods:{

	},
	mounted(){

			var uid=storage.get('userdata')
			if(uid==null){

				$('.nav-dis').attr('disabled','true')

			}

			if(storage.get('userdata')!=null){
				$('.nav1').attr('disabled','true')
				$('.nav3').attr('disabled','true')
				$('.nav4').attr('disabled','true')
			}
			if(storage.get('yyjl')=='yyjl'){
				$('.nav1').attr('disabled','true')
				$('.nav2').attr('disabled','true')
				$('.nav4').attr('disabled','true')
			}
			if(storage.get('wdxz')=='wdxz'){
				$('.nav1').attr('disabled','true')
				$('.nav2').attr('disabled','true')
				$('.nav3').attr('disabled','true')
			}
			if(storage.get('wdsp')=='wdsp'){
				$('.nav1').attr('disabled','true')
				$('.nav2').attr('disabled','true')
				$('.nav3').attr('disabled','true')
				$('.nav4').attr('disabled','true')
			}

	},
}
</script>
<style>
<<<<<<< HEAD
=======

>>>>>>> dev

.el-checkbox__label{
	font-size: 16px!important;
	font-weight: 400;
}

.el-input__icon{
	line-height: 34px!important;
}
.el-date-editor .el-icon-circle-close{

}
</style>




// WEBPACK FOOTER //
// src/components/per_admin/P_Edit.vue